// Builds the customer's own cover as the cart thumbnail
// (snippets/cart-cover-thumb.liquid): the product page's drawing for that
// size, per-cell kontakter/stik as they chose, coloured by the --cover-*
// variables Liquid already set on the container.
//
// Loaded on every page: the added-to-cart popup shows one too, and it can
// open anywhere. It only does work when a .cart-cover-thumb is present, and
// watches for new ones because Dawn re-renders the cart's contents (and the
// popup's) by swapping innerHTML whenever something changes.
(function () {
  var docCache = {};

  function coverDoc(url) {
    if (!url) return Promise.resolve(null);
    if (!docCache[url]) {
      docCache[url] = fetch(url)
        .then(function (res) {
          return res.text();
        })
        .then(function (txt) {
          var doc = new DOMParser().parseFromString(txt, 'image/svg+xml');
          // A failed fetch still yields a document — reject it rather than
          // put the browser's parse-error page in the cart.
          if (doc.querySelector('parsererror') || doc.documentElement.tagName.toLowerCase() !== 'svg') {
            throw new Error('not an svg: ' + url);
          }
          return doc;
        });
    }
    return docCache[url];
  }

  // The Kontakter line-item value, as written by product-color-customizer.js:
  // "1 kontakt", "2 kontakter", "1 stik", "1 + 2 (øverst → nederst)" or
  // "1 stik + 2 kontakter (øverst → nederst)". One entry per cell.
  function parseStates(value) {
    var body = (value || '').replace(/\s*\(.*\)\s*$/, '').trim();
    if (!body) return [];
    return body.split(' + ').map(function (part) {
      if (/stik/.test(part)) return 'stik';
      return /^\s*2\b/.test(part) ? 2 : 1;
    });
  }

  // Same composition as the product page: start from the 1-kontakt drawing
  // and swap in each cell's group(s) from the 2-kontakter or socket drawing.
  function compose(el) {
    var states = parseStates(el.dataset.kontakter);
    var needs = { 2: states.indexOf(2) !== -1, stik: states.indexOf('stik') !== -1 };
    return Promise.all([
      coverDoc(el.dataset.coverOne),
      needs[2] ? coverDoc(el.dataset.coverTwo) : null,
      needs.stik ? coverDoc(el.dataset.coverStik) : null,
    ]).then(function (docs) {
      var one = docs[0];
      var from = { 2: docs[1], stik: docs[2] };
      var root = one.documentElement.cloneNode(true);
      [].slice.call(root.querySelectorAll('.cover-pin')).forEach(function (g) {
        var cell = parseInt(g.getAttribute('data-cell'), 10);
        var source = from[states[cell]];
        if (!source) return;
        [].forEach.call(source.querySelectorAll('.cover-pin[data-cell="' + cell + '"]'), function (p) {
          g.parentNode.insertBefore(one.importNode(p, true), g);
        });
        g.parentNode.removeChild(g);
      });
      return root;
    });
  }

  function build(el) {
    el.dataset.coverState = 'loading';
    var made;
    if (el.dataset.coverOne) {
      made = compose(el);
    } else if (el.dataset.coverSrc) {
      made = coverDoc(el.dataset.coverSrc).then(function (doc) {
        return doc.documentElement.cloneNode(true);
      });
    } else {
      el.dataset.coverState = 'none';
      return;
    }
    made
      .then(function (root) {
        var title = root.querySelector('title');
        if (title) title.parentNode.removeChild(title);
        root.setAttribute('aria-hidden', 'true');
        root.setAttribute('focusable', 'false');
        root.setAttribute('class', 'cart-cover-thumb__art');
        el.innerHTML = '';
        el.appendChild(document.importNode(root, true));
        el.dataset.coverState = 'ready';
      })
      .catch(function () {
        // Keep the plain catalogue drawing that's already there.
        el.dataset.coverState = 'failed';
      });
  }

  function scan() {
    [].forEach.call(document.querySelectorAll('.cart-cover-thumb:not([data-cover-state])'), build);
  }

  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
